import { render, staticRenderFns } from "./RFQ.vue?vue&type=template&id=386a5a94&scoped=true"
import script from "./RFQ.vue?vue&type=script&lang=js"
export * from "./RFQ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386a5a94",
  null
  
)

export default component.exports